import React, { useState, createContext, useMemo } from 'react';
import logComponent from '../common/logComponent';

// create context
const CheckinContext = createContext(null);

// declare provider component 
const CheckinProvider = ({ children }) => {
  const [checkinInProgress, setCheckinInProgress] = useState(false);
  const [mostRecentCheckinCompletionTime, setMostRecentCheckinCompletionTime] = useState(null);

  const startCheckin = () => {
    if (logComponent('CheckinContext')) { console.debug('CheckinContext startCheckin'); }
    setCheckinInProgress(true);
  }

  const endCheckin = () => {
    if (logComponent('CheckinContext')) { console.debug('CheckinContext endCheckin'); }
    setCheckinInProgress(false);
    setMostRecentCheckinCompletionTime(Date.now());
  }
  const checkInState = useMemo(() => ({
    checkinInProgress: checkinInProgress,
    mostRecentCheckinCompletionTime: mostRecentCheckinCompletionTime,
    startCheckin: startCheckin,
    endCheckin: endCheckin
  }), [checkinInProgress,
    mostRecentCheckinCompletionTime
  ]);

  return (
    <CheckinContext.Provider value={checkInState}>
      {children}
    </CheckinContext.Provider>
  );
}

// export provider and context
export { CheckinProvider, CheckinContext };